var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectionsCarCategory7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.469,
    height: 25.119,
    viewBox: "0 0 28.469 25.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "directions_car_24dp_E8EAED_FILL1_wght300_GRAD0_opsz24",
    d: "M143.542-718.23v2.093a1.215,1.215,0,0,1-.361.895,1.216,1.216,0,0,1-.9.361h-1.03a1.214,1.214,0,0,1-.895-.361,1.214,1.214,0,0,1-.361-.895v-12.849l3.42-9.758a1.721,1.721,0,0,1,.686-.916,1.929,1.929,0,0,1,1.111-.34h18.1a1.785,1.785,0,0,1,1.068.345,1.78,1.78,0,0,1,.665.911l3.42,9.758v12.849a1.214,1.214,0,0,1-.361.895,1.214,1.214,0,0,1-.895.361h-1.03a1.216,1.216,0,0,1-.9-.361,1.215,1.215,0,0,1-.361-.895v-2.093ZM143.53-731.5h21.409l-2.113-5.99H145.642Zm3.108,8.824a2.1,2.1,0,0,0,1.55-.64,2.122,2.122,0,0,0,.636-1.554,2.1,2.1,0,0,0-.64-1.55,2.123,2.123,0,0,0-1.554-.636,2.1,2.1,0,0,0-1.55.64,2.122,2.122,0,0,0-.636,1.554,2.1,2.1,0,0,0,.64,1.55A2.121,2.121,0,0,0,146.638-722.674Zm15.2,0a2.1,2.1,0,0,0,1.55-.64,2.121,2.121,0,0,0,.636-1.554,2.1,2.1,0,0,0-.64-1.55,2.122,2.122,0,0,0-1.554-.636,2.1,2.1,0,0,0-1.55.64,2.123,2.123,0,0,0-.636,1.554,2.1,2.1,0,0,0,.64,1.55,2.122,2.122,0,0,0,1.554.636Z",
    transform: "translate(-140 740)",
    fill: "#85899c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionsCarCategory7);
export default __webpack_public_path__ + "static/media/directions_car_category_7.7d3c26d28b09b483448ad3023d5969f3.svg";
export { ForwardRef as ReactComponent };